const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';
import { type ProPatient } from '@/context/ProIntakeContext';

/** Shape of data submitted from IntakeModal / EmergencyIntakeModal */
interface IntakeFormData {
  species?: string;
  petName?: string;
  ownerName?: string;
  ownerEmail?: string;
  ownerPhone?: string;
  breedKey?: string;
  lastVisit?: string;
  nextVaccineDueNow?: boolean;
  nextVaccineDate?: string;
  petDid?: string;
  microchip?: string;
  emergencyType?: string;
}
export const Route = createFileRoute('/pro/dashboard')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** Small standalone component — avoids variable-scope issues in the large dashboard chunk */

/** Shows the member's assigned branch name — must be inside LocationProvider */

/** Color map for navigation group border + label */

interface NavTab {
  id: string;
  path: string;
  label: string;
  icon: LucideIcon;
}
interface NavGroup {
  label: string;
  color: string;
  tabs: NavTab[];
  row?: 1 | 2;
}

/** Single category button with dropdown */